import { format } from "date-fns";
import { InsuranceAttributesProps, PatientPhoneNumber, PrescriptionAttributesType } from "src/pages/addCase/types";
import { PatientTitleProps } from "src/types/case";

export const DEFAULT_DRUG_NAME = "Furoscix";

export const PATIENT_TITLE: readonly PatientTitleProps[] = [
  {
    label: 'Mr.',
    value: 'mr',
  },
  {
    label: 'Ms.',
    value: 'ms',
  },
  {
    label: 'Mrs.',
    value: 'mrs',
  },
  {
    label: 'Miss',
    value: 'miss',
  },
];

export const PATIENT_GENDER: PatientTitleProps[] = [
  {
    label: 'Male',
    value: 'M',
  },
  {
    label: 'Female',
    value: 'F',
  },
];

export const PATIENT_TIME_TO_CONTACT: PatientTitleProps[] = [
  {
    label: 'Morning',
    value: 'morning',
  },
  {
    label: 'Afternoon',
    value: 'afternoon',
  },
  {
    label: 'Evening',
    value: 'evening',
  },
];

export const PATIENT_PHONE_TYPES: PatientTitleProps[] = [
  {
    label: 'Cell',
    value: 'cell',
  },
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'Work',
    value: 'work',
  },
];

export const PATIENT_ADDR_TYPES: PatientTitleProps[] = [
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'Work',
    value: 'work',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const PATIENT_INSURANCE_TYPE: PatientTitleProps[] = [
  {
    label: 'Self',
    value: 'self',
  },
  {
    label: 'Spouse',
    value: 'spouse',
  },
  {
    label: 'Guardian',
    value: 'guardian',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const PATIENT_SITE_TYPE: PatientTitleProps[] = [
  {
    label: 'Physician Office',
    value: 'office',
  },
  {
    label: 'Ambulatory Surgical Center',
    value: 'asc',
  },
  {
    label: 'Hospital Outpatient',
    value: 'hospital',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const PATIENT_PHARMACY_INSTRUCTIONS: PatientTitleProps[] = [
  {
    label: 'Initial Course - 5 Refills',
    value: 'standard'
  },
  {
    label:'Maintenance Course - 10 Refills',
    value: 'maintenance'
  },
  {
    label: 'Initial Course Bilateral - 5 Refills',
    value: 'bilateral'
  },
  {
    label: 'Bilateral Maintenance Course - 10 Refills',
    value: 'bilateral_maintenance',
  }
];

export const CASE_STATUS_LISTING: { label: string; value: string | boolean; }[] = [
  {
    label: 'All Cases',
    value: '',
  },
  {
    label: 'Active Cases',
    value: true,
  },
  {
    label: 'Closed Cases',
    value: false,
  },
];

export const TREATMENT_STATUS_LISTING: { label: string; value: string | boolean; }[] = [
  {
    label: 'All Treatments',
    value: '',
  },
  {
    label: 'Active Treatments',
    value: true,
  },
  {
    label: 'Closed Treatments',
    value: false,
  },
];

export const ORDER_STATUS_LISTING: { label: string; value: string | boolean; }[] = [
  {
    label: 'All Orders',
    value: '',
  },
  {
    label: 'Active Orders',
    value: true,
  },
  {
    label: 'Closed Orders',
    value: false,
  },
];

export const CASE_HEADER_LISTING = [
  {
    value: 'id',
    label: 'ID',
  },
  {
    value: '',
    label: 'Review Type',
  },
  {
    value: '',
    label: 'Rx Submitted',
  },
  {
    value: '',
    label: 'BI Investigated',
  },
  {
    value: '',
    label: 'Product',
  },
  {
    value: '',
    label: 'Rx Shipped',
  },
  {
    value: 'patient_firstlastname',
    label: 'Patient',
  },
  {
    value: 'doctor_firstlastname',
    label: 'Prescriber',
  },
  {
    value: '',
    label: 'Pharmacy',
  },
  {
    value: 'status_name',
    label: 'Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
  {
    value: '',
    label: 'Actions',
  },
];

export const DOCTOR_HEADER_LISTING = [
  {
    value: 'id',
    label: 'ID',
  },
  {
    value: '',
    label: 'Doctor Name',
  },
  {
    value: '',
    label: 'NPI',
  },
  {
    value: '',
    label: 'Signature',
  },
];

export const TREATMENT_HEADER_LISTING = [
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: '',
    label: 'Instillation',
  },
  {
    value: '',
    label: 'Ordered'
  },
  {
    value: '',
    label: 'Delivery ETA',
  },
  {
    value: '',
    label: 'Patient',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: 'status_name',
    label: 'Treatment Status',
  },
  {
    value: '',
    label: 'Next Steps',
  },
];

export const ORDER_HEADER_LISTING = [
  {
    value: 'id',
    label: 'ID',
  },
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: 'po_number',
    label: 'Customer PO',
  },
  {
    value: 'user_name',
    label: 'Ordered By',
  },
  {
    value: 'created_at',
    label: 'Ordered Date',
  },
  {
    value: 'completed_at',
    label: 'Completed Date',
  },
  {
    value: '',
    label: 'Status',
  },
];

export const STATE_TREATMENT = [
  {
    value: 'Cost',
    label: 'Cost',
  }, {
    value: 'Off Label',
    label: 'Off Label',
  }, {
    value: 'PA Denied',
    label: 'PA Denied',
  }, {
    value: 'Patient Refused Treatment',
    label: 'Patient Refused Treatment',
  }, {
    value: 'Step Edits Not Met',
    label: 'Step Edits Not Met',
  }, {
    value: 'Unable to Contact Patient',
    label: 'Unable to Contact Patient',
  },{
    value: 'Patient Given Another Treatment Option',
    label: 'Patient Given Another Treatment Option',
  },{
    value:'Patient No Longer Sees Prescriber',
    label:'Patient No Longer Sees Prescriber',
  },{
    value:'Patient Deceased',
    label:'Patient Deceased',
  },{
    value:'Patient Had Side Effect / Adverse Event',
    label:'Patient Had Side Effect / Adverse Event',
  },{
    value: 'Other',
    label: 'Other',
  }
];

export const DRUG_QUANTITY = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 7,
    label: "7",
  },
  {
    value: 9,
    label: "9",
  },
  {
    value: 10,
    label: "10",
  },
];

export const INJECTION_SITE = [
  {
    value: "left",
    label: "Left",
  },
  {
    value: "right",
    label: "Right",
  },
  {
    value: "bilateral",
    label: "Bilateral",
  },
];

export const SHIP_TO = [
  {
    value: "provider",
    label: "Provider",
  },
  {
    value: "patient",
    label: "Patient",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const CASE_CATEGORY = {
  rx: "Pharmacy",
  med: "Medical",
  medrx: "Both"
};

export const RETREATMENT_TABLE_HEADER = [
  {
    value: 'id',
    label: 'ID',
  },
  {
    value: 'created_at',
    label: 'Submitted',
  },
  {
    value: 'patient_firstlastname',
    label: 'Patient',
  },
  {
    value: 'doctor_firstlastname',
    label: 'Physician',
  },
  {
    value: '',
    label: 'Patient Phone',
  },
  {
    value: '',
    label: 'Actions',
  },
];
export const COLOR_LIST = [
  "#7cb5ec","#434348","#90ed7d","#f7a35c","#8085e9","#f15c80","#e4d354","#2b908f","#f45b5b","#91e8e1"
]

// export const CASE_FORM_DEFAULT_VALUES: AddCaseProps = {
//   mos: "online",
//   submission_source: "provider",
//   category: "rx",
//   uploaded_documents: [],
//   api_pa_approved: false,
//   creator_name: "",
//   user_id: 0,
//   doctor_firstlastname: "",
//   doctor_fullname: "",
//   original_id: 0,
//   patient_dob: "",
//   patient_firstlastname: "",
//   patient_fullname: "",
//   practice_name: "",
//   shipments_attributes: [{
//     ship_to_city: "",
//     ship_to_state: "",
//     ship_to_street: "",
//     ship_to_suite: "",
//     ship_to_zip: ""
//   }],

//   doctor_attributes: {
//     global_doctor_id: 0,
//     practice_id: 0,
//   },

//   case_attributes: {
//     pa_approved: "",
//     pa_approved_date: "",
//     ship_to: "",
//   },

//   prescription_attributes: {
//     drug_name: "Furoscix",
//     direction: "Administer 1 dose(80mg) subcutaneously via the On-Body infusor once daily as directed",
//     quickstart: false,
//     cp_diuretics: {
//       diuretics_tried: {
//         furosemide_props: {},
//         furosemide: false,
//         torsemide_props: {},
//         torsemide: false,
//         bumetanide: false,
//         bumetanide_props: {},
//       }
//     },
//     condition: "",
//     diagnosis_code: [],
//     injection_site: "",
//     review_type: "",
//     note: "",
//     scheduled_date_of_service: "",
//     written_date: format(new Date(), 'MM/dd/yyyy'),
//   },
//   patient_attributes: {
//     global_patient_id: 0,
//     title: "",
//     firstname: "",
//     middlename: "",
//     lastname: "",
//     gender: "",
//     dob: "",
//     patient_email_id: null,
//     patient_email: "",
//     best_time_to_contact: "",
//     language: "",
//     ssn: "",
//     address: {
//       address_name: "home",
//       city: "",
//       state: "",
//       street: "",
//       zip: "",
//       suite: "",
//     },
//     phone_numbers: [
//       {
//         phone_type: "cell",
//         id: null,
//         is_ok_to_leave_message: false,
//         is_preferred: false,
//         number: "",
//       },
//     ],
//   },
//   insurances_attributes: [
//     {
//       global_insurance_id: null,
//       is_primary_insurance: true,
//       insurance_priority: 0,
//       insurance_name: "",
//       policy: "",
//       relation_to_patient: "",
//       bin: "",
//       group_number: "",
//       insurance_number: "",
//       member_id: "",
//       pcn: "",
//       plan_type: "",
//       relation_firstname: "",
//       relation_lastname: "",
//       relation_middlename: "",
//       rx_group: "",
//     },
//   ],
// };

export const CASE_FORM_PRESCRIPTION_VALUES: PrescriptionAttributesType = {
  drug_name: "Furoscix",
  direction: "Administer 1 dose(80mg) subcutaneously via the On-Body infusor once daily as directed",
  quickstart: false,
  cp_diuretics: {
    diuretics_tried: {
      furosemide_props: {},
      furosemide: false,
      torsemide_props: {},
      torsemide: false,
      bumetanide: false,
      bumetanide_props: {},
    },
    creatinine_clearance: "",
    eGFR: "",
  },
  condition: "",
  diagnosis_code: [],
  injection_site: "",
  review_type: "",
  note: "",
  scheduled_date_of_service: "",
  written_date: format(new Date(), 'MM/dd/yyyy'),
  frequency_of_use: "",
  daily_dose: "",
}

export const STATUS_REASON = [
  
  {
    value: 'Change in Medical Condition',
    label: 'Change in Medical Condition',
  }, 
  {
    value: 'Cost',
    label: 'Cost',
  }, 
  {
    value: 'Duplicate Case',
    label: 'Duplicate Case',
  }, 
  {
    value: 'Not Covered By Insurance',
    label: 'Not Covered By Insurance',
  }, 
  {
    value: 'PA denied',
    label: 'PA denied',
  },
  {
    value: 'Patient refused',
    label: 'Patient refused',
  }, 
  {
    value: 'Unable to contact patient',
    label: 'Unable to contact patient',
  }, 
  {
    value: 'Other',
    label: 'Other',
  }
];
export const CASE_REVIEW_TYPES = [
  {
    "id": "cp",
    "name": "Expedited 24-Hour Review Required: CONTACT PATIENT",
    "value": "cp"
  },
  {
    "id": "dncp",
    "name": "Coverage & Copay Determination ONLY: DO NOT CONTACT PATIENT",
    "value": "dncp"
  }
]

export const CASE_REVIEW_TYPES_ON_BODY_INFUSOR = [
  {
    "id": "cp",
    "name": "Expedited 24-Hour Review Required: CONTACT PATIENT",
    "value": "cp"
  },
  {
    "id": "dncp",
    "name": "Coverage & Copay Determination ONLY: DO NOT CONTACT PATIENT",
    "value": "dncp"
  }
]
export const CASE_REVIEW_TYPES_FOR_READYFLOW = [
  
  {
    "id": "dncp",
    "name": "Coverage & Copay Determination ONLY: DO NOT CONTACT PATIENT",
    "value": "dncp"
  }
]
export const FREQUENCY_TYPES = [
 
  // {
  //   "id": "Daily",
  //   "name": "Daily",
  //   "value": "Daily"
  // },
  {
    "id": "Daily as Directed",
    "name": "Daily as Directed",
    "value": "Daily as Directed"
  },
  {
    "id": "PRN as Directed",
    "name": "PRN as Directed",
    "value": "PRN as Directed"
  },
  {
    "id": "Twice Daily",
    "name": "Twice Daily",
    "value": "Twice Daily"
  },
  // {
  //   "id" : "Three Times Daily (TID)",
  //   "name": "Three Times Daily (TID)",
  //   "value": "Three Times Daily (TID)"
  // },
  // {
  //   "id": "Four Times Daily (QID)",
  //   "name": "Four Times Daily (QID)",
  //   "value": "Four Times Daily (QID)"   
  // },
  {
    "id": "Every Other Day",
    "name": "Every Other Day",
    "value": "Every Other Day"
  },
  {
    "id": "Weekly",
    "name": "Weekly",
    "value": "Weekly"
  },
  // {
  //   "id": "Monthly",
  //   "name": "Monthly",
  //   "value": "Monthly"
  // },
  // {
  //   "id": "PRN (As Needed)",
  //   "name": "PRN (As Needed)",
  //   "value": "PRN (As Needed)"
  // },
  // {
  //   "id": "Other",
  //   "name": "Other",
  //   "value": "Other"
  // }
]
export const DAILY_DOSE_TYPES = [
  
  {
    "id": "1 dose/day",
    "name": "1 dose/day",
    "value": "1 dose/day"
  },
  {
    "id": "2 doses/day",
    "name": "2 doses/day",
    "value": "2 doses/day"
  },
  {
    "id": "Other",
    "name": "Other",
    "value": "Other"
  }
]

export const NYHA_CLASSES = [
  {
    "id":"CKD",
    "name": "CKD",
    "value": "CKD"
  },
  {
    "id": "HF",
    "name": "HF",
    "value": "HF"
  },
  {
    "id": "HF & CKD",
    "name": "HF & CKD",
    "value": "HF & CKD"
  }
]

export const CASE_FORM_DEFAULT_VALUES = {
  mos: "online",
  user_id: 0,
  creator_name: "",
  submission_source: "provider",
  category: "rx",
  uploaded_documents: [],
  api_pa_approved: false,
  prescription_attributes: {
   
    frequency_of_use: "",
    daily_dose: "",
    drug_name: "",
    direction: "",
    quickstart: false,
    refills_authorized: 0,
    cp_diuretics: {
      diuretics_tried: {
        bumetanide: false,
        bumetanide_props: {},
        furosemide: false,
        furosemide_props: {},
        torsemide: false,
        torsemide_props: {},
      }
    },
    written_date: format(new Date(), 'MM/dd/yyyy'),
  },
  patient_attributes: {
    address: {
      address_name: "home",
    },
    phone_numbers: [
      {
        phone_type: "cell",
        id: null,
      } as PatientPhoneNumber,
    ],
  },
  insurances_attributes: [
    {
      global_insurance_id: null,
      is_primary_insurance: true,
      insurance_priority: 0,
    } as unknown as InsuranceAttributesProps,
  ],
}
